import React, { Component } from "react";
import { Merchantroutes } from "./Merchant/index";
import { Branchroutes } from "./Branch/index";
import { SuperAdminroutes } from "./SuperAdmin/index";
import { Redirect, Route, Switch } from "react-router-dom";
import { NewUserroutes } from "./New";
import { Waiterroutes } from "./Waiter";
export default class Load extends Component {
  constructor(props) {
    super(props);
    this.state = { route: null };
  }
  componentDidMount() {
    this.setState({ loading: true });
    let payload = localStorage.getItem("Ubytes");
    if (payload) {
      let user = JSON.parse(payload);

      if (user.role == "Branch") {
        let branchRoutes = Branchroutes();
        this.setState({ route: branchRoutes });
      } else if (user.role == "Merchant") {
        let merchantRoutes = Merchantroutes();
        this.setState({ route: merchantRoutes });
      } else if (user.role == "Superadmin") {
        let superAdminRoutes = SuperAdminroutes();
        this.setState({ route: superAdminRoutes });
      } else if (user.role == "Waiter") {
        this.setState({ route: Waiterroutes() });
      }
    } else {
      let newUserRoutes = NewUserroutes();
      this.setState({ route: newUserRoutes });
    }
    this.setState({ loading: false });
  }

  render() {
    if (this.state.loading) {
      <div>Loading...</div>;
    }
    return <Switch>{this.state.route}</Switch>;
  }
}
